import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { WelcomeComponent } from './welcome/welcome.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { GamesComponent } from './games/games.component';
import { MallsComponent } from './malls/malls.component';
import { ShopsComponent } from './shops/shops.component';
import { UsersComponent } from './users/users.component';
import { UserComponent } from './user/user.component';
import { PromocodesComponent } from "./promocodes/promocodes.component";
import { ShopProfileComponent } from './shop/shop-profile/shop-profile.component';
import { ShopPromocodesComponent } from './shop/shop-promocodes/shop-promocodes.component';
import { MallProfileComponent } from './mall/mall-profile/mall-profile.component';
import { GameDetailComponent } from './game-detail/game-detail.component';
import { ShopDetailComponent } from './shop-detail/shop-detail.component';
import { MallDetailComponent } from './mall-detail/mall-detail.component';

import { AddshopComponent } from './shops/addshop/addshop.component';
import { AddmallComponent } from './malls/addmall/addmall.component';
import { MallShopsComponent } from './mall-shops/mall-shops.component';
import { MallShopDetailComponent } from './mall-shop-detail/mall-shop-detail.component';

import { AuthGuardService } from "./services/auth-guard.service";

const routes: Routes =[
    { path: 'shop_profile',  component: ShopProfileComponent, canActivate:[AuthGuardService] },
    { path: 'shop_promocodes', component:ShopPromocodesComponent,canActivate:[AuthGuardService]},
    { path: 'mall_profile', component:MallProfileComponent,canActivate:[AuthGuardService]},
    { path: 'games', component:GamesComponent,canActivate:[AuthGuardService]  },
    { path: 'games/game/detail/:id', component:GameDetailComponent,canActivate:[AuthGuardService]  },
    { path: 'shops', component: ShopsComponent,canActivate:[AuthGuardService]  },
    { path: 'shops/addshop', component: AddshopComponent,canActivate:[AuthGuardService]  },
    { path: 'shops/shop/:id', component: ShopDetailComponent,canActivate:[AuthGuardService]  },
    { path: 'users', component: UsersComponent,canActivate:[AuthGuardService]  }, 
    { path: 'users/user/:id', component: UserComponent,canActivate:[AuthGuardService]  }, 
    { path: 'malls', component: MallsComponent ,canActivate:[AuthGuardService] }, 
    { path: 'mall/shops', component: MallShopsComponent,canActivate:[AuthGuardService] }, 
    { path: 'mall/shops/shop/:id', component: MallShopDetailComponent,canActivate:[AuthGuardService] }, 
    { path: 'malls/addmall', component: AddmallComponent,canActivate:[AuthGuardService]  },
    { path: 'malls/mall/:id', component: MallDetailComponent ,canActivate:[AuthGuardService] }, 
    { path: 'promocodes', component: PromocodesComponent,canActivate:[AuthGuardService]},      
    { path: 'dashboard', component: HomeComponent, canActivate:[AuthGuardService]},
    { path: 'welcome', component:  WelcomeComponent, canActivate:[AuthGuardService]},

    { path: 'login',        component: LoginComponent },
    { path: '',          redirectTo: 'welcome', pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
 
  ],
  exports: [ RouterModule ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/app.routing.ts